import moment from "moment";
import { get } from "svelte/store";
import { user } from "../../app.store";
export function dossierExpiringDescription(dossier, formattedDate) {
    let deltaDays = moment(dossier.deadlineDate).diff(moment().startOf('day'), 'day');
    let theUser = get(user);
    let deltaDaysThreshold = theUser != null ? theUser.regionSettings.expirationWarningDays : 10;
    if (deltaDays <= deltaDaysThreshold) {
        let msg = '';
        let red = false;
        if (deltaDays < -1) {
            msg = `Scaduta ${-deltaDays} giorni fa`;
            red = true;
        }
        else if (deltaDays == -1) {
            msg = `Scaduta ieri`;
            red = true;
        }
        else if (deltaDays == 0) {
            msg = `Scade oggi`;
            red = true;
        }
        else if (deltaDays == 1) {
            msg = `Scade domani`;
            red = true;
        }
        else if (deltaDays > 1) {
            msg = `Scade tra ${deltaDays} giorni`;
        }
        let iconColor = red ? 'red' : 'orange';
        let icon = `<i class="material-icons" style="float:right;line-height:unset;cursor:default;color:${iconColor};" title="${msg}">warning_amber</i>`;
        return formattedDate + icon;
    }
    return formattedDate;
}
